import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=962c9e70&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=962c9e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962c9e70",
  null
  
)

export default component.exports